<template>
    <div>
        <CFormGroup label="Názov">
            <CFormInput
                class="white"
                :disabled="disabled"
                :has-suffix="$attrs['hasSuffix']"
                :suffix-icon="$attrs['suffixIcon']"
                :model-value="modelValue.achievement"
                @update:model-value="update({ achievement: $event })"
            />
        </CFormGroup>

        <CFormGroup label="Rok">
            <CFormSelect
                allow-empty
                :disabled="disabled"
                :has-suffix="$attrs['hasSuffix']"
                :options="availableYearOptions"
                placeholder="Vybrať rok"
                :suffix-icon="$attrs['suffixIcon']"
                :model-value="modelValue.year"
                @update:model-value="update({ year: Number($event) })"
            />
        </CFormGroup>

        <CFormGroup class="!mb-0" label="Popis">
            <CWysiwyg
                :allowed-buttons="['back', 'forward', 'bold', 'italic', 'strike', 'orderedList', 'bulletList']"
                :disabled="disabled"
                :model-value="modelValue.desc"
                @update:model-value="update({ desc: $event })"
            />
        </CFormGroup>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Achievement } from '#shared/types/User'

const props = defineProps<{
    modelValue: Achievement
    disabled?: boolean
}>()

const emit = defineEmits<{
    'update:modelValue': [value: Achievement]
}>()

const availableYearOptions = computed(() => {
    const maxYearsAgo = 60
    const year = new Date().getFullYear()

    return [...Array(maxYearsAgo)].map((_, index) => year - index)
})

const update = (change: Partial<Achievement>) => {
    emit('update:modelValue', { ...props.modelValue, ...change })
}
</script>